import { useEffect, useState } from 'react';
import { MenuOutlined } from '@ant-design/icons';
import { Button, Drawer, Flex, Grid, theme, Typography } from 'antd';
import { Link } from 'react-router';
import { destinos } from '../destinos';
import { Logotipo, SeletorDeTema } from '@titularis/ui';

/** Geometria original do cabeçalho; Módulos ocupa o antigo link de planos. */
const ANCORAS = [
  { href: '/#como-funciona', rotulo: 'Como funciona' },
  { href: '/#modulos', rotulo: 'Módulos' },
  { href: '/provas', rotulo: 'Provas grátis' },
  { href: '/noticias', rotulo: 'Notícias' },
  { href: '/revista', rotulo: 'Revista' },
  { href: '/#duvidas', rotulo: 'Dúvidas' },
];

export function Cabecalho() {
  const { token } = theme.useToken();
  const telas = Grid.useBreakpoint();
  const [rolou, setRolou] = useState(false);
  const [gaveta, setGaveta] = useState(false);

  useEffect(() => {
    const aoRolar = () => setRolou(window.scrollY > 24);
    aoRolar();
    window.addEventListener('scroll', aoRolar, { passive: true });
    return () => window.removeEventListener('scroll', aoRolar);
  }, []);

  const links = (aoClicar?: () => void) =>
    ANCORAS.map((ancora) => {
      const estilo = { color: token.colorText, fontSize: token.fontSize };

      /*
       * Rota interna vai pelo `Link`, âncora vai pelo `<a>`. O `Link` não
       * serve para o `/#planos`: ele navegaria sem recarregar e o navegador
       * não rolaria até a seção, porque o hash chega depois de a tela já ter
       * sido montada. O `<a>` recarrega e o salto acontece sozinho.
       */
      return ancora.href.includes('#') ? (
        <a key={ancora.href} href={ancora.href} onClick={aoClicar} style={estilo}>
          {ancora.rotulo}
        </a>
      ) : (
        <Link key={ancora.href} to={ancora.href} onClick={aoClicar} style={estilo}>
          {ancora.rotulo}
        </Link>
      );
    });

  return (
    <header
      className="site-cabecalho"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 20,
        background: rolou ? token.colorBgContainer : 'transparent',
        borderBottom: `1px solid ${rolou ? token.colorSplit : 'transparent'}`,
        transition: 'background 0.2s, border-color 0.2s',
      }}
    >
      <Flex
        align="center"
        justify="space-between"
        // No celular o respiro vira largura de logotipo, e a barra so tem dois
        // blocos com `space-between` - o vao ali nao separa nada, so limita.
        // Com 24 a marca teria de cair para 22 num aparelho de 320px.
        gap={telas.md ? 24 : 8}
        style={{
          position: 'relative',
          maxWidth: 1120,
          marginInline: 'auto',
          height: 68,
          paddingInline: telas.sm ? 20 : 12,
        }}
      >
        {/*
          Na landing o logotipo fica **a esquerda**, e o menu vai para a direita
          - o arranjo de site de vendas, e o que a voa.health usa. E de
          proposito diferente do app: la o logotipo e centralizado.

          A diferenca nao e capricho. Aqui a barra tem uma acao que precisa ser
          clicada ("Criar conta") e o logotipo e ancora de marca para quem
          acabou de chegar de um link; no app, quem esta dentro ja sabe onde
          esta, e a barra e navegacao.
        */}
        {/* `/`, e não `#topo`: de uma notícia aberta, o logotipo tem de voltar
            para a landing, e não rolar a própria página até o alto. */}
        <a href="/" aria-label="Titularis, início">
          {/* A marca menor reserva espaço para cadastro, menu e scrollbar em 320px. */}
          <Logotipo altura={telas.md ? 28 : telas.sm ? 26 : 22} />
        </a>

        {telas.xl ? (
          <>
            <Flex align="center" gap={28}>
              {links()}
            </Flex>
            <Flex align="center" gap={8}>
              {/*
                O seletor de tema vem antes dos botoes de conta e mais apagado
                que eles: e ajuste de conforto, nao acao do funil. Colocado
                depois de "Criar conta" ele competiria com o unico botao que a
                pagina precisa que seja clicado.
              */}
              <SeletorDeTema />
              <Button href={destinos.entrar}>Entrar</Button>
              <Button type="primary" href={destinos.criarConta}>
                Criar conta
              </Button>
            </Flex>
          </>
        ) : (
          <Flex align="center" gap={4}>
            <Button type="primary" href={destinos.criarConta}>
              Criar conta
            </Button>
            <Button
              type="text"
              aria-label="Abrir menu"
              icon={<MenuOutlined />}
              onClick={() => setGaveta(true)}
            />
          </Flex>
        )}
      </Flex>

      <Drawer
        placement="right"
        size={280}
        open={gaveta}
        onClose={() => setGaveta(false)}
        title={<Logotipo altura={22} />}
      >
        <Flex vertical gap={20}>
          {links(() => setGaveta(false))}
          <Button href={destinos.entrar} block>
            Entrar
          </Button>
          {/* Na gaveta ha largura para o nome do tema; no cabecalho, nao. */}
          <div>
            <Typography.Text
              type="secondary"
              style={{ fontSize: 12, display: 'block', marginBottom: 8 }}
            >
              Tema
            </Typography.Text>
            <SeletorDeTema comRotulo tamanho="middle" />
          </div>
        </Flex>
      </Drawer>
    </header>
  );
}
